import { ReactNode } from 'react';

interface PageSEOProps {
  title: string;
  description: string;
  keywords: string;
  canonicalPath?: string;
  schema?: Record<string, unknown>;
  children: ReactNode;
}

export default function PageSEO({ title, description, keywords, canonicalPath, schema, children }: PageSEOProps) {
  document.title = title;

  const setMeta = (name: string, content: string, property = false) => {
    const attr = property ? 'property' : 'name';
    let el = document.querySelector(`meta[${attr}="${name}"]`);
    if (!el) {
      el = document.createElement('meta');
      el.setAttribute(attr, name);
      document.head.appendChild(el);
    }
    el.setAttribute('content', content);
  };

  setMeta('description', description);
  setMeta('keywords', keywords);

  if (canonicalPath) {
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    link.setAttribute('href', `https://guanghua2020.cn${canonicalPath}`);
  }

  setMeta('og:title', title, true);
  setMeta('og:description', description, true);
  setMeta('og:url', `https://guanghua2020.cn${canonicalPath || '/'}`, true);
  setMeta('twitter:title', title);
  setMeta('twitter:description', description);

  return (
    <>
      {schema && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
      {children}
    </>
  );
}